const compact = <T>(
  ...elements: (T | undefined | null | false | 0 | '')[]
): T[] => elements.filter(x => x) as T[]

export default compact
